import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconGiroCards: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-1.5-IconGiroCards"><Path fillRule="evenodd" clipRule="evenodd" d="M2 4H18V8H22V20H6V16H2V4ZM7.5 16V18.5H20.5V9.5H18V16H7.5ZM6 8H9V9.5H6V8Z" fill="currentColor"/></CentralIconBase>;
});

export default IconGiroCards;
